import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '@services/core/user.service';
import { StorageService } from '@services/core/storage.service';

export const authGuard: CanActivateFn = (route, state) => {
    const userService = inject(UserService)
    const storageService = inject(StorageService)
    const router = inject(Router)

    if (!storageService.getJsonValue('logged')) {
        return router.parseUrl('/')
    }

    const menus = userService.sharingMenu()

    if (menus.length === 0) {
        return true
    }

    function flattenMenuUrls(items: any[]): string[] {
        const urls: string[] = []
        for (const item of items) {
            if (item.url) urls.push(item.url)
            if (item.submenu?.length) urls.push(...flattenMenuUrls(item.submenu))
        }
        return urls
    }

    const allowedUrls = flattenMenuUrls(menus)
    const requestedUrl = state.url.replace(/^\//, '').split('?')[0]

    if (allowedUrls.includes(requestedUrl)) {
        return true
    }

    return router.parseUrl('/cerpro')
}
